import * as React from "react";
import WidgetBot from "@widgetbot/react-embed";

const WidgetBots = () => {
  //   return <WidgetBot server="1007597121706401852" channel="1016020594430582804" />;
  return <></>;
};

export default WidgetBots;
